// extracted by mini-css-extract-plugin
export default {"wrapper":"s0rHfl","fitToLayout":"hq54Ut"};